// src/api/messages.ts
import { APICore } from './apiCore';

const api = new APICore();
interface ChatUserType {
    id: number;
    name: string;
    phone_number: string;
}
function getContacts(): Promise<{ data: ChatUserType[] }> {
    const baseUrl = '/contacts';
    return api.get(baseUrl);
}

function getMessagesForUser(contactId: number): Promise<{ data: any[] }> {
    const baseUrl = `/whatsapp/receive/${contactId}`;
    return api.get(baseUrl);
}

function MessageUsers(id: any): Promise<{ data: any }> {
    const baseUrl = `/receive/${id}`;
    return api.get(baseUrl);
}

function sendMessage(params: {
    message: string;
    type: string;
    phone_number: any;
    company_id?: any;
    contact_id: any;
    broadcast_id: any;
}) {
    const baseUrl = '/whatsapp/send';
    return api.create(baseUrl, params);
}

function updateMessageStatus(messageId: number, status: string) {
    const baseUrl = `/messages/${messageId}/status`;
    return api.update(baseUrl, { status });
}
function sendMediaMessage(data: FormData) {
    const baseUrl = '/whatsapp/send-media';
    return api.create(baseUrl, data);
}
export const sendTemplateMessage = (data: {
    template_id: number;
    contact_id: number;
    company_id: number;
    variables?: string[]; // 👈 ADD THIS
}) => {
    return api.create("/whatsapp/send-template", data);
};
export const getMessageStatus = (id: number) => {
    return api.get(`/messages/${id}/status`);
};
export const sendButtonMessage = (id: string) => {
    return api.get(`/whatsapp/interaction/${id}`);
};
function assignChat(data: {
    contact_id: number;
    assigned_to: 'user' | 'automation';
}) {
    const baseUrl = '/whatsapp/assign-chat';
    return api.update(baseUrl, data);
}

export {
    sendMediaMessage,
    getMessagesForUser,
    MessageUsers,
    getContacts,
    sendMessage,
    updateMessageStatus,
    assignChat
};